import { instanceApi } from './api'

export const getShouldShowSetup = async() => {
  const response = await instanceApi.get( `v1/assinatura/check-configuracao` )
  const { paginaSetup } = response.data

  return {
    'exibir': paginaSetup.exibir,
    'setupEmAndamento': paginaSetup.setupEmAndamento,
    'tipo': paginaSetup.tipo,
    'isReativacao': paginaSetup.isReativacao,
  }
}
